// extracted by mini-css-extract-plugin
module.exports = {"container":"confirmationCode_container__s5DZK","resendCode":"confirmationCode_resendCode__EU0U6"};